export const PREFORM_TECHMAP_OPERATION_CLOSED_STATUSES = ['released', 'canceled'];
export const PREFORM_TECHMAP_OPERATION_ISSUE_DETAILS_STATUSES = ['accepted_at_storage', 'partially_issued'];
